import styled, { css } from 'styled-components';
import { BaSeTheme } from '../../theme';

export interface BoardListWrapperProps {
  length: number;
  itemMinWidth?: number | string;
  itemMaxWidth?: number | string;
  loadingValidDrop: boolean;
}

export interface BoardListColumnProps {
  bgColor?: string;
  bgColorHeader?: string;
}

export const BoardListsWrapper = styled.section.attrs({
  className: 'BaSe--board',
})<BoardListWrapperProps>`
  &.BaSe--board {
    gap: 0.5em;
    padding: 1em;

    min-height: 0;
    height: 100%;
    margin: auto;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      pointer-events: none;
      z-index: 1;
      display: ${({ loadingValidDrop }) =>
        loadingValidDrop ? 'block' : 'none'};
    }
  }
`;

export const BoardColumnContainer = styled.section.attrs({
  className: 'BaSe--board-column-container',
})`
  &.BaSe--board-column-container {
    height: 100%;
    padding: 0.5em;
    gap: 1em;
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
  }
`;

export const ContainerLoading = styled.div.attrs({
  className: 'BaSe--container-loading',
})`
  &.BaSe--container-loading {
    flex: 1;
  }
`;

export const BoardItemsWrapper = styled.div.attrs({
  className: 'BaSe--board-items',
})`
  &.BaSe--board-items {
  }
`;

export const BoardItem = styled.div.attrs({
  className: 'BaSe--board-item',
})`
  &.BaSe--board-item {
    margin: 10px 0;
  }
`;

export const BoardWithoutItems = styled.section.attrs({
  className: 'BaSe--board-without-items',
})<{ bgColor: string | undefined }>`
  &.BaSe--board-without-items {
    ${({ bgColor }) => css`
      background-color: ${bgColor ?? BaSeTheme.colors.defaultColors.lightGray};
    `}

    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    white-space: initial;

    overflow: hidden;

    text-overflow: ellipsis;
  }
`;

export const BoardItemListWrapper = styled.div.attrs({
  className: 'BaSe--board--list--item--wrapper',
})<{ loading: boolean }>`
  &.BaSe--board--list--item--wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    user-select: none;
  }
`;

export const BoardColumnHeader = styled.section.attrs({
  className: 'BaSe--board-column-header',
})<BoardListColumnProps>`
  &.BaSe--board-column-header {
    ${({ bgColorHeader }) => css`
      background-color: ${bgColorHeader ??
      BaSeTheme.colors.institucionais.azulSebrae36};
    `}

    height: 47px;
    padding: 5px 10px;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    justify-content: space-between;

    position: relative;
  }
`;

export const BoardColumnCompressed = styled.section.attrs({
  className: 'BaSe--board-column-compressed',
})<BoardListColumnProps>`
  &.BaSe--board-column-compressed {
    ${({ bgColorHeader }) => css`
      background-color: ${bgColorHeader ??
      BaSeTheme.colors.institucionais.azulSebrae36};
    `}

    width: 3.75em;
    padding: 5px 10px;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
  }
`;

export const AlignHeaderTitle = styled.section.attrs({
  className: 'BaSe--board-align-title-header',
})<BoardListColumnProps>`
  &.BaSe--board-align-title-header {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    text-align: center;
    padding: 5px 0;
  }
`;
export const AlignTitleCollumnCompressed = styled.section.attrs({
  className: 'BaSe--board-align-title-collumn-compressed',
})<BoardListColumnProps>`
  &.BaSe--board-align-title-collumn-compressed {
    writing-mode: vertical-lr;
  }
`;

export const AlignHeaderRight = styled.section.attrs({
  className: 'BaSe--board-align-header-right',
})<BoardListColumnProps>`
  &.BaSe--board-align-header-right {
    position: absolute;
    right: 0;
    top: 48%;
    transform: translateY(-48%);
  }
`;

export const BoardColumnContent = styled.div.attrs({
  className: 'BaSe--board-column-content',
})<BoardListColumnProps>`
  padding: 10px;
  ${({ bgColor }) => css`
    background-color: ${bgColor ?? BaSeTheme.colors.defaultColors.lightGray};
  `}

  height: 80vh;
  -ms-overflow-style: none;
  overflow-y: scroll;
`;
